import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import contactSagas from './contacts/saga';
import companySagas from './company/saga';

// export default function* rootSaga(getState) {
export default function* rootSaga() {
    yield all([
    authSagas(),
    companySagas(),
    contactSagas(),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas.js